import React, { useState, useEffect, useCallback } from 'react';

let _showToast: ((msg: string, duration?: number) => void) | null = null;

export function showToast(msg: string, duration = 2600) {
  _showToast?.(msg, duration);
}

const Toast: React.FC = () => {
  const [msg,     setMsg]     = useState('');
  const [visible, setVisible] = useState(false);
  const [timer,   setTimer]   = useState<ReturnType<typeof setTimeout> | null>(null);

  const show = useCallback((message: string, duration = 2600) => {
    setMsg(message);
    setVisible(true);
    if (timer) clearTimeout(timer);
    setTimer(setTimeout(() => setVisible(false), duration));
  }, []);

  useEffect(() => { _showToast = show; return () => { _showToast = null; }; }, [show]);

  return (
    <div className={`toast ${visible ? 'show' : ''}`}>{msg}</div>
  );
};

export default Toast;
